import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => (
  <FormattedMessage id="subscribe-modal.continue-button.text" defaultMessage="Continue" />
);
